import { __assign } from "tslib";
var observedAttributes = {
    VALUE: 'value',
    MULTIPLE: 'multiple',
    OBSERVE_SCROLL: 'observe-scroll',
    OBSERVE_SCROLL_THRESHOLD: 'observe-scroll-threshold',
    HIGHLIGHT_FIRST: 'highlight-first',
    SELECT_ON_BLUR: 'select-on-blur',
    POPUP_CLASSES: 'popup-classes',
    OPTION_LIMIT: 'option-limit',
    SYNC_POPUP_WIDTH: 'sync-popup-width'
};
var attributes = __assign({}, observedAttributes);
var events = {
    CHANGE: 'change'
};
export var BASE_SELECT_CONSTANTS = {
    attributes: attributes,
    events: events
};
